// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2AIB-","left":"Header_left__3r8Jf","right":"Header_right__pVqV8","iconWrapper":"Header_iconWrapper__QsqaK","badge":"Header_badge__rfVDz"};